var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable max-lines */
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { ApolloLink, useApolloClient } from '@apollo/client';
import { inject, observer } from 'mobx-react';
import { ClientLogger } from 'bernie-client';
import { updateSearch } from 'bernie-core';
import { getAdBlockerEventParams } from 'bernie-plugin-ads-loader-script';
import { ErrorBoundary } from 'bernie-view';
import { parse } from 'query-string';
import { QualtricsExperiments } from 'src/common/components/search/qualtrics';
import { SplitView } from 'src/common/components/search/split-view';
import { DynamicSearchMapContextProvider } from 'src/common/stores/contexts/map/dynamic-search-map-context';
import { RefProvider } from 'src/common/stores/contexts/ref-provider';
import { View, ViewTrackerContextProvider } from 'src/common/stores/contexts/viewTracker';
import { SrpTemplate } from 'src/common/stores/page-layout/page-layout-store-utils';
import { LODGING_PRODUCT_LINE, PropertyListingQueryApolloAnalyticsLink } from 'src/common/utils/apollo-link-util';
import { getHotelSearchPageData } from 'src/common/utils/controller-utils/page-data-util';
import { isMobile } from 'src/common/utils/is-mobile';
import { Experiment, ExperimentControl, ExperimentVariant, useExperiment } from '@shared-ui/experiment-context';
import { GridViewContextProvider, OneKeyBannerToggleContext } from '@shared-ui/lodging-property-listing';
import { SessionOperationsProvider } from '@shared-ui/multi-item-operations-providers';
import { RefProviderRoot } from '@shared-ui/ref-context';
import { CompareAdaptExProvider } from '@shared-ui/retail-compare-providers';
import { GoogleMapsSdkVersionProvider } from '@shared-ui/retail-map-google-maps-sdk-version-provider';
import { ProductType, ProductTypeProvider } from '@shared-ui/retail-product-type-providers';
import { LodgingQueryParamsProvider, useLodgingURLParamsToQueryInputs } from '@shared-ui/retail-search-tools-lodging';
import { SignalEventsContextProvider } from '@shared-ui/signal-events-context';
import { PubSubEventManager } from '@shared-ui/signal-events-context_pub-sub-observer';
import { ShortlistProvider } from 'components/common/shortlist/shortlist-provider';
import { MasterPage } from 'components/layout/pages/master-page';
import { ResultsAccessibilityHeadingRegion } from 'components/layout/pages/results-accessibility-heading-region';
import { isInBrowser } from 'components/meso/utils';
import { AnnounceLoadingState } from 'components/search/announce-loading-state';
import { TemplateRenderer } from 'components/search/template-components/template-renderer';
import { MapsSdkVersion } from '../../constants/maps';
import { SearchPageName } from 'constants/pages';
const logger = ClientLogger.getLoggerWithIdentifier('pwa.component.search');
let SearchComponent = class SearchComponent extends React.Component {
  constructor(props) {
    var _a, _b, _c, _d;
    super(props);
    this.setView = this.setView.bind(this);
    this.state = {
      view: View.LISTINGS
    };
    if (this.props.context && this.props.searchResults && this.props.searchResults.searchCriteria && this.props.searchResults.searchCriteria.multiProp === 'true') {
      this.props.multiItem && this.props.multiItem.getOrCreateCart(this.props.context);
    }
    (_a = this.props.advertising) === null || _a === void 0 ? void 0 : _a.includeAd();
    if ((_b = this.props.multiItem) === null || _b === void 0 ? void 0 : _b.multiItemContext) {
      const pageName = SearchPageName[this.props.multiItem.multiItemContext.packageType];
      if (pageName) {
        (_c = this.props.advertising) === null || _c === void 0 ? void 0 : _c.trigger(pageName);
      }
    } else {
      (_d = this.props.advertising) === null || _d === void 0 ? void 0 : _d.trigger('page.Hotels.Search');
    }
  }
  componentDidMount() {
    this.trackDisambiguationSearch();
    this.trackSearchResultsError();
    this.sendAdBlockerEvent();
  }
  analyticsTrackEvent(referrer, linkName, omnitureData) {
    if (this.props.analytics && typeof this.props.analytics.trackEvent === 'function') {
      this.props.analytics.trackEvent(referrer, linkName, omnitureData);
    }
  }
  sendAdBlockerEvent() {
    if (isInBrowser()) {
      const {
        referrer,
        linkName
      } = getAdBlockerEventParams();
      this.analyticsTrackEvent(referrer, linkName, null);
    }
  }
  trackDisambiguationSearch() {
    if (this.props.multiItem && this.props.multiItem.isDisambigSearch()) {
      if (this.props.analytics && typeof this.props.analytics.trackEvent === 'function') {
        const events = [{
          name: 'SearchResultsDisambig',
          error: false
        }];
        this.props.analytics.trackEvent(this.props.multiItem.referrer, 'package disambig search', null, events);
      }
    }
  }
  trackSearchResultsError() {
    var _a;
    const isError = (_a = this.props.searchResults) === null || _a === void 0 ? void 0 : _a.isError;
    if (isError) {
      this.analyticsTrackEvent('SorryMessage', 'SorryMessage', null);
    }
  }
  setView(view) {
    this.setState({
      view
    });
  }
  render() {
    var _a, _b;
    const {
      analyticsSearch,
      context,
      searchResults,
      multiItem,
      pageLayout
    } = this.props;
    const isMixMatchCart = multiItem && multiItem.cartInfo && multiItem.cartInfo.identifier === 'mixAndMatch';
    const isMultiItem = multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath();
    if (isMixMatchCart && context && multiItem && multiItem.itemCount > 0) {
      multiItem.emptyCart(context);
    }
    let searchPage;
    if ((pageLayout === null || pageLayout === void 0 ? void 0 : pageLayout.templateName) === SrpTemplate.SplitView) {
      searchPage = React.createElement(ErrorBoundary, {
        label: "lodging.search.splitView"
      }, React.createElement(SplitView, null));
    } else {
      const templateContent = React.createElement(Experiment, {
        name: "increased_real_estate_shopping_experience"
      }, React.createElement(ExperimentControl, null, React.createElement("div", {
        className: "constrain-width"
      }, React.createElement(TemplateRenderer, null))), React.createElement(ExperimentVariant, {
        bucket: 1
      }, React.createElement("div", {
        className: "increased_real_estate_shopping_experience_1"
      }, React.createElement(TemplateRenderer, null))), React.createElement(ExperimentVariant, {
        bucket: 2
      }, React.createElement("div", {
        className: "increased_real_estate_shopping_experience_2"
      }, React.createElement(TemplateRenderer, null))));
      searchPage = React.createElement(MasterPage, {
        route: this.props.route,
        searchCriteria: searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria,
        pageHeader: searchResults === null || searchResults === void 0 ? void 0 : searchResults.resultsHeading,
        templateContent: templateContent
      });
    }
    if (!searchResults) return;
    return React.createElement(ViewTrackerContextProvider, {
      viewTracker: {
        view: this.state.view,
        setView: this.setView
      }
    }, React.createElement(ShortlistProvider, null, React.createElement(CompareAdaptExProvider, {
      propertySearchCriteria: this.props.propertySearchCriteriaInput
    }, React.createElement(SessionOperationsProvider, null, React.createElement(SignalEventsContextProvider, {
      eventManager: PubSubEventManager
    }, React.createElement(DynamicSearchMapContextProvider, null, React.createElement(RefProvider, null, React.createElement(RefProviderRoot, null, React.createElement(GridViewContextProvider, null, React.createElement(GoogleMapsSdkVersionProvider, {
      version: MapsSdkVersion.google
    }, React.createElement(ProductTypeProvider, {
      productType: ProductType.Lodging
    }, React.createElement(OneKeyBannerToggleContext.Provider, {
      value: {
        analyticsSearch,
        updateSearch
      }
    }, isMultiItem && React.createElement(AnnounceLoadingState, {
      isLoading: (_a = this.props.searchResults) === null || _a === void 0 ? void 0 : _a.isLoading,
      isError: (_b = this.props.searchResults) === null || _b === void 0 ? void 0 : _b.isError
    }), React.createElement(ResultsAccessibilityHeadingRegion, {
      isHiddenFromScreenReader: true
    }), searchPage, React.createElement(QualtricsExperiments, null)))))))))))));
  }
};
SearchComponent = __decorate([inject('advertising', 'analytics', 'context', 'multiItem', 'searchResults', 'uiPage', 'pageLayout'), observer], SearchComponent);
// FC to consume LodgingQueryParamsProvider via hook
const SearchComponentWithPropertySearchCriteriaInput = props => {
  var _a;
  return React.createElement(SearchComponent, Object.assign({}, props, {
    propertySearchCriteriaInput: (_a = useLodgingURLParamsToQueryInputs()) === null || _a === void 0 ? void 0 : _a.propertySearchCriteriaInput
  }));
};
const SearchComponentWrapper = inject('analytics', 'experiment', 'multiItem', 'analyticsSearch', 'page', 'searchResults', 'context')(_a => {
  var _b, _c;
  var {
      analytics,
      experiment,
      multiItem,
      analyticsSearch,
      page,
      searchResults,
      context
    } = _a,
    props = __rest(_a, ["analytics", "experiment", "multiItem", "analyticsSearch", "page", "searchResults", "context"]);
  const client = useApolloClient();
  const isMultiItem = multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath();
  const isMoveSearchResultsHotelExperiment = ((_c = (_b = experiment === null || experiment === void 0 ? void 0 : experiment.exposures) === null || _b === void 0 ? void 0 : _b.srp_move_searchresultshotel_to_clientside) === null || _c === void 0 ? void 0 : _c.bucket) === 1;
  const {
    exposure: bexgSplitViewExposure,
    logExperiment: logBEXGSplitViewExperiment
  } = useExperiment('Split_View_Side_by_side_BEXG_H');
  const {
    exposure: excludeMapFromVrboMobileSearchExposure,
    logExperiment: logExcludeMapFromVrboMobileSearchExperiment
  } = useExperiment('Exclude_map_from_search_query_vrbo_mobile');
  const {
    exposure: expandableMapViewOnSRPExposure,
    logExperiment: logExpandableMapViewOnSRPWebExposure
  } = useExperiment('Expandable_Map_View_on_SRP_Web');
  React.useEffect(() => {
    logExpandableMapViewOnSRPWebExposure(expandableMapViewOnSRPExposure);
  }, [logExpandableMapViewOnSRPWebExposure, expandableMapViewOnSRPExposure]);
  React.useEffect(() => {
    if (isMobile(context)) {
      logExcludeMapFromVrboMobileSearchExperiment(excludeMapFromVrboMobileSearchExposure);
    } else {
      logBEXGSplitViewExperiment(bexgSplitViewExposure);
    }
  }, [bexgSplitViewExposure, excludeMapFromVrboMobileSearchExposure, context]);
  if ((!isMultiItem || isMoveSearchResultsHotelExperiment) && analyticsSearch) {
    const analyticsLink = PropertyListingQueryApolloAnalyticsLink(analytics, logger, analyticsSearch, LODGING_PRODUCT_LINE, context.site.brand, experiment);
    if (!analyticsSearch.apolloLinkSetOnServer) {
      client.setLink(ApolloLink.from([analyticsLink, client.link]));
      analyticsSearch.apolloLinkSetOnServer = true;
    } else if (typeof window !== 'undefined' && !analyticsSearch.apolloLinkSetInBrowser) {
      client.setLink(ApolloLink.from([analyticsLink, client.link]));
      analyticsSearch.apolloLinkSetInBrowser = true;
    }
  }
  const location = useLocation();
  const {
    pageId,
    pageName
  } = getHotelSearchPageData(parse(location.search));
  const {
    search
  } = useLocation();
  const urlSearchParams = React.useMemo(() => new URLSearchParams(search), [search]);
  if (page) {
    page.pageId = pageId;
    page.pageName = pageName;
    searchResults.pageId = pageId;
  }
  return React.createElement(LodgingQueryParamsProvider, {
    urlSearchParams: urlSearchParams
  }, React.createElement(Experiment, {
    name: "Lodging_Tag_Commander_Delay"
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  }), React.createElement(ExperimentVariant, {
    bucket: 2
  }), React.createElement(ExperimentVariant, {
    bucket: 3
  })), React.createElement(SearchComponentWithPropertySearchCriteriaInput, Object.assign({}, props, {
    analyticsSearch: analyticsSearch,
    experiment: experiment,
    page: page
  })));
});
export default React.memo(SearchComponentWrapper);